import React, { createContext } from 'react';

import { WsSalesSolutionItem } from '../../core';




type WsSalesSolutionViewContextProps = {
  moveItem: WsSalesSolutionItem | undefined;
  setMoveItem: React.Dispatch<React.SetStateAction<WsSalesSolutionItem | undefined>>;
};




const initialValues: WsSalesSolutionViewContextProps = {
  moveItem: undefined,
  setMoveItem: () => {
    console.log('WsSalesSolutionViewContext : setMoveItem');
  }
};




const WsSalesSolutionViewContext = createContext<WsSalesSolutionViewContextProps>(initialValues);




export {
  WsSalesSolutionViewContext
};
